import { MtGroup } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setGroupList = (groupList: types.GroupList) => ({
    type: inferLiteral(types.GROUP_LIST),
    groupList,
})
export const setGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.GROUP_IDS),
    groupIds,
})
export const setGroupView = (group: MtGroup) => ({
    type: inferLiteral(types.GROUP_VIEW),
    group,
})
export const setGroupEdit = (group: MtGroup) => ({
    type: inferLiteral(types.GROUP_EDIT),
    group,
})
export const setAccountGroups = (groups: types.GroupList) => ({
    type: inferLiteral(types.ACCOUNT_GROUPS),
    groups,
})
export const setGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setGroupFilters = (filters: types.GroupFilters) => ({
    type: inferLiteral(types.GROUP_FILTERS),
    filters,
})
export const setGroupReloadList = (value: boolean) => ({
    type: inferLiteral(types.GROUP_RELOAD_LIST),
    value,
})
export const setGroupReloadView = (value: boolean) => ({
    type: inferLiteral(types.GROUP_RELOAD_VIEW),
    value,
})
export const setGroupReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.GROUP_RELOAD_EDIT),
    value,
})
